import { LoadingButton } from "@mui/lab";
import {
  Button,
  DialogActions,
  DialogProps,
  DialogTitle,
  Dialog,
} from "@mui/material";
import React from "react";
import { I18nTranslator } from "utils/i18n";
import { translations } from "utils/i18n";

export enum EMDialogType {
  NORMAL,
  SUCCESS,
  WARNING,
  ERROR,
}

interface IMDialog extends DialogProps {
  title: string;
  type?: EMDialogType;
  handleClose?: () => void;
  handleDelete?: () => void;
  handleConfirm?: () => void;
  loading?: boolean;
  renderMoreButton?: JSX.Element;
}

type COLOR_TYPE =
  | "inherit"
  | "primary"
  | "success"
  | "error"
  | "secondary"
  | "info"
  | "warning";

const MDialog = (props: IMDialog) => {
  const {
    title,
    type = EMDialogType.NORMAL,
    handleClose,
    handleDelete,
    handleConfirm,
    loading = false,
    children,
    renderMoreButton,
  } = props;

  const _getType = () => {
    switch (type) {
      case EMDialogType.NORMAL:
        return {
          color: "primary",
        };
      case EMDialogType.SUCCESS:
        return {
          color: "success",
        };
      case EMDialogType.WARNING:
        return {
          color: "error",
        };
      case EMDialogType.ERROR:
        return {
          color: "error",
        };
    }
  };

  return (
    <Dialog
      {...props}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle sx={{ fontWeight: "700" }} color={_getType().color}>
        {title}
      </DialogTitle>
      {children}
      <DialogActions>
        {renderMoreButton}
        {handleClose && (
          <Button onClick={handleClose}>
            {I18nTranslator(translations.button.cancel)}
          </Button>
        )}

        {handleDelete && (
          <LoadingButton
            onClick={handleDelete}
            variant={"contained"}
            color={_getType().color as COLOR_TYPE}
            loading={loading}
          >
            {I18nTranslator(translations.button.delete)}
          </LoadingButton>
        )}
        {handleConfirm && (
          <LoadingButton
            onClick={handleConfirm}
            variant={"contained"}
            color={_getType().color as COLOR_TYPE}
            loading={loading}
          >
            {I18nTranslator(translations.button.confirm)}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default MDialog;
